import * as THREE from "three";

/**
 * Оборачивает Mesh в группу, перенося позицию, вращение и имя на группу.
 * Если объект уже является Group, возвращает его как есть.
 * @param {THREE.Object3D} object
 * @returns {THREE.Group|THREE.Object3D}
 */
export function wrapMeshInGroup(object, index) {
    if (object.isGroup) {
        return object;
    }

    if (!object.isMesh) {
        throw new Error("Аргумент должен быть Mesh или Group");
    }

    const group = new THREE.Group();

    const originalName = object.name;

    group.name = originalName;

    object.name = `${originalName}__mesh`;
    if (typeof index === "number") {
        group.name += `__${index}`;
    }

    object.userData.isWrappedMesh = true;
    group.userData.isWrapperGroup = true;

    // копируем трансформации
    group.position.copy(object.position);
    group.rotation.copy(object.rotation);

    Object.assign(group.userData, object.userData);

    // сбрасываем трансформации меша
    object.position.set(0, 0, 0);
    object.rotation.set(0, 0, 0);

    group.add(object);

    return group;
}

export function wrapedAllObjectInAllArr() {
    for (const key in servObj) {
        if (key.startsWith("all") && Array.isArray(servObj[key]) && servObj[key].length) {
            servObj[key] = servObj[key].map((item, index) => {
                if (item instanceof THREE.Mesh && !item.userData.isWrappedMesh) {
                    return wrapMeshInGroup(item, index);
                }
                return item;
            });
        }
    }
}
